import React, { Component, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as router from "react-router-dom";
import { Container } from "reactstrap";

import {
  AppAside,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppBreadcrumb2 as AppBreadcrumb,
  AppSidebarNav2 as AppSidebarNav,
} from "@coreui/react";
import routes from "routes";

const DefaultFooter = React.lazy(() => import("./DefaultFooter"));
const DefaultHeader = React.lazy(() => import("./DefaultHeader"));
const FlashMessageAlert = React.lazy(() => import("common/FlashMessageAlert"));
class DefaultLayout extends Component {
  state = {
    accessRoutes: [],
  };
  loading = () => (
    <div className="animated fadeIn pt-1 text-center">Loading...</div>
  );

  signOut(e) {
    e.preventDefault();
    //this.props.history.push("/login");
  }
  componentDidMount() {
    const user = this.props.items;
    let accessRoutes = [];
    // push dashboard
    accessRoutes.push({
      ...{id:"0", name:"Dashboard", path:"/dashboard", readAccess:"1", writeAccess:"1"},
      ...routes.find((route) => route.id === "0"),
    });
    if (user.routes !== null) {
      for (let i = 0; i < user.routes.length; i++) {
        accessRoutes.push({
          ...user.routes[i],
          ...routes.find((route) => route.id === user.routes[i].id),
        });
      }
    }
    console.log("accessRoutes ", accessRoutes);
    this.setState({ accessRoutes });
  }
  render() {
    const { accessRoutes } = this.state;

    return (
      <div className="app">
        <AppHeader fixed>
          <Suspense fallback={this.loading()}>
            <DefaultHeader {...this.props} />
          </Suspense>
        </AppHeader>
        <div className="app-body">
          <AppSidebar fixed display="lg">
            <AppSidebarHeader />
            <AppSidebarForm />
            <Suspense>
              <AppSidebarNav
                navConfig={this.props.items}
                router={router}
                history={this.props.history}
                location={this.props.location}
              />
            </Suspense>
            <AppSidebarFooter />
            <AppSidebarMinimizer />
          </AppSidebar>
          <main className="main">
            {/* <AppBreadcrumb
              appRoutes={
                this.props.items.routes === null ? [] : this.props.items.routes
              }
              router={router}
            /> */}
           
            <Container fluid>
              <Suspense fallback={this.loading()}>
                <>
                <FlashMessageAlert/>
                <Switch>
                  {accessRoutes.map((route, idx) => {
                    return route.component ? (
                      <Route
                        key={idx}
                        path={route.path}
                        exact={route.exact}
                        name={route.name}
                        render={(props) => (
                          <route.component
                            {...props}
                            route={route}
                          />
                        )}
                      />
                    ) : null;
                  })}
                  <Redirect from="/" to="/dashboard" />
                </Switch>
                </>
              </Suspense>
            </Container>
          </main>
          <AppAside fixed>
            <Suspense fallback={this.loading()}></Suspense>
          </AppAside>
        </div>
        <AppFooter>
          <Suspense fallback={this.loading()}>
            <DefaultFooter />
          </Suspense>
        </AppFooter>
      </div>
    );
  }
}

export default DefaultLayout;
